import Vue from 'vue'

const migrationRedirect = function(response) {
    if(response && response.data && response.data.result && response.data.result.url) {
        const url = response.data.result.url;
        const href = window.location.href;
        const origin = window.location.origin;
        const addToUrl = href.replace(origin, '####');
        window.location.replace(url + addToUrl);
    }
};

export default {
    state: {
        user: {}
    },
    mutations: {},
    actions: {

        checkInvitation({commit}, {token}) {
            return new Promise((resolve, reject) => {
                Vue.axios.get('v1/api/invitation/register/', {
                    params: {
                        token: token
                    }
                }).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                })
            });
        },

        registerByInvitation({commit}, {user, token}) {
            return new Promise((resolve, reject) => {
                Vue.axios.post('v1/api/invitation/register/', {...user, token}).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                })
            });
        },
        register({commit}, {user, token}) {
            return new Promise((resolve, reject) => {
                Vue.axios.post('v1/api/user/register/', {...user, token}).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                })
            });
        },
        register2({commit}, {user}) {
            return new Promise((resolve, reject) => {
                Vue.axios.post('v1/web/user/register/', user).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                })
            });
        },
        login({commit}, {user}) {
            const formData = new FormData();
            formData.append('user', user.userName);
            formData.append('passwd', user.password);

            const rememberMe = user.rememberMe !== false; // use rememberMe as default

            return new Promise((resolve, reject) => {
                Vue.axios.post('json/auth/?action=login&remember-me=' + rememberMe, formData).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    migrationRedirect(error.response);
                    reject(error.response);
                })
            });
        },
        loginWithToken({commit}, {token}) {
            return new Promise((resolve, reject) => {
                Vue.axios.post('json/auth/token/?remember-me=true', {token}).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                })
            });
        },
        logout({commit}) {
            return new Promise((resolve, reject) => {
                Vue.axios.get('json/auth/?action=logout').then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                })
            });
        },
        joinContext({commit}, {token}) {
            const formData = new FormData();
            formData.append('token', token);
            return new Promise((resolve, reject) => {
                Vue.axios.post('v1/api/invitations/', formData).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                })
            });
        },
        isLoggedIn({commit}) {
            return new Promise((resolve, reject) => {
                Vue.axios.get('json/auth/?action=isAuth').then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                })
            });
        },
        requestPasswordReset({commit}, {email}) {
            return new Promise((resolve, reject) => {
                Vue.axios.get('v1/api/auth/reset/', {
                    params: {email: email}
                }).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                })
            });
        },
        resetPassword({commit}, {password, token}) {
            return new Promise((resolve, reject) => {
                Vue.axios.post('v1/api/auth/reset/', {
                    token: token,
                    passwd: password
                }).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(error.response);
                })
            });
        }
    },
    getters: {}
};
